import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { WithdrawalInFiatCurrencyStepUI } from "@src/widgets/onboarding/ui/tours/AccountTopUp/WithdrawalInFiatCurrencyStepUI"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class WithdrawalInFiatCurrencyStepSubmit extends TourStepBase {
  component = WithdrawalInFiatCurrencyStepUI
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_WithdrawalInFiatCurrencyStep`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_WITHDRAWFIAT_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT,
    })
  }

  action() {
    return router.navigate({
      pathname: generatePath(paths.withdrawFiat, {
        network: "fiat",
        symbol: "EUR",
      }),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Step 2: Submit a request",
      title: "Withdrawal in Fiat Currency",
    }
  }
}
